export default __webpack_public_path__ + "static/media/icon-group.5ce1fea6.svg";